import { StoreItem, StoreItemResponse, useStoreApi } from '@givebacks/api/store';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { useCrowdfundingProvider } from '../../../../Context';
import { useCampaignInfoByProvider } from '../../../new/campaigns/utils/campaignUtils';
import { createCauseQueryString } from '../../../new/campaigns/utils/createQueryString';
import { createCauseQuery } from '../../../utils';

const useShowDonationStoreItem = ({ causeId }: { causeId?: string } = {}) => {
  const StoreApi = useStoreApi();
  const { causeId: _causeId } = useCampaignInfoByProvider();
  const causeQuery = createCauseQueryString(causeId ?? _causeId);
  const getStoreItem = async () => {
    const { data } = await StoreApi.get<StoreItemResponse<StoreItem>>(
      `/store_items/donations?${causeQuery}`
    );
    return data.store_item;
  };
  return useQuery({
    queryKey: [causeId ?? _causeId, 'crowdfunding', 'donations'],
    queryFn: getStoreItem,
    enabled: !!causeQuery,
  });
};

const useUpdateDonationStoreItem = <T extends Partial<StoreItem>>() => {
  const StoreApi = useStoreApi();
  const queryClient = useQueryClient();
  const { causeId } = useCrowdfundingProvider();
  const causeQuery = createCauseQuery(causeId);
  const updateStoreItem = async (donationStoreItemRequest: T) => {
    const { data } = await StoreApi.put<StoreItemResponse<StoreItem>>(
      `/store_items/donations?${causeQuery}`,
      {
        cause_id: causeId,
        store_item: donationStoreItemRequest,
      }
    );
    return data.store_item;
  };
  return useMutation({
    mutationFn: updateStoreItem,
    onSuccess: () => {
      return queryClient.invalidateQueries({ queryKey: [causeId, 'crowdfunding', 'donations'] });
    },
  });
};

export { useShowDonationStoreItem, useUpdateDonationStoreItem };
